import {Component, HostListener, OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {DomainService} from "./services/admin/domain.service";
@Component({
  selector: 'app-root',
  template: `
      <app-app-layout>
          <router-outlet></router-outlet>
      </app-app-layout>
  `,
})
export class AppComponent implements OnInit {
  private ultimaRutaValida: string = '';

  constructor(
    private router: Router,
    private domainService: DomainService
  ) {}

  @HostListener('window:resize')
  onResize(): void {
    this.ajustarClasesMenu();
  }

  ajustarClasesMenu(): void {
    const body = document.body;
    const isMobile = window.innerWidth < 1200;

    body.classList.add('vertical-layout');
    body.classList.add('navbar-floating');
    body.classList.add('footer-static');

    if (isMobile) {
      body.classList.remove('vertical-menu-modern', 'menu-expanded');
      body.classList.add('vertical-overlay-menu', 'menu-hide');
      body.classList.remove('menu-open');

      const overlay = document.querySelector('.sidenav-overlay');
      overlay?.classList.remove('show');

      if ((window as any).$?.app?.menu) {
        (window as any).$.app.menu.hidden = true;
        (window as any).$.app.menu.expanded = false;
      }
    } else {
      body.classList.remove('vertical-overlay-menu', 'menu-hide', 'menu-open');
      body.classList.add('vertical-menu-modern');
      if (!body.classList.contains('menu-collapsed')) {
        body.classList.add('menu-expanded');
      }

      const overlay = document.querySelector('.sidenav-overlay');
      overlay?.classList.remove('show');
    }
  }

  ngOnInit(): void {
    this.ajustarClasesMenu();

    setTimeout(() => {
      if ((window as any).$?.app?.menu?.init) {
        const isCollapsed = document.body.classList.contains('menu-collapsed');
        (window as any).$.app.menu.init(isCollapsed);
      }
    }, 150);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // En cada cambio de ruta, sincronizar y cerrar el menú móvil después de que los componentes hijos monten su ngOnInit
        setTimeout(() => {
          this.ajustarClasesMenu();
        }, 100);

        const url = event.urlAfterRedirects.toLowerCase();

        // Evitar loops de redirección
        if (url === '/error' || url.startsWith('/error')) {
          this.ultimaRutaValida = url;
          return;
        }

        console.log('DOMINIO INFO:', this.domainService.getDomainInfo());
        console.log('RUTA:', url);

        // ================================
        // Validación dominio
        // ================================
        if (!this.domainService.esPrincipal()) {

          if (!this.domainService.esDominioValido()) {
            this.router.navigate(['/error']);
            return;
          }

          const permitido = this.domainService.rutasPublicas.some(r =>
            url.startsWith(r)
          );

          if (!permitido) {
            this.router.navigate(['/error']);
            return;
          }
        }

        this.ultimaRutaValida = url;
      });
  }
}
